/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip as ChakraTooltip, Portal } from "@chakra-ui/react";

export interface TooltipProps extends ChakraTooltip.RootProps {
  showArrow?: boolean;
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement>;
  content: React.ReactNode;
  contentProps?: ChakraTooltip.ContentProps;
  arrowProps?: ChakraTooltip.ArrowTipProps;
  disabled?: boolean;
  icon?: any;
  placement?: "top" | "bottom" | "right" | "left" | "top-start" | "top-end" | "bottom-start" | "bottom-end" | "right-start" | "right-end" | "left-start" | "left-end";
}

export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(
  (props, ref) => {
    const {
      showArrow = true,
      placement = "top",
      children,
      disabled,
      portalled = true,
      content,
      contentProps = {},
      arrowProps = {},
      portalRef,
      icon,
      ...rest
    } = props;

    const [isOpen, setIsOpen] = React.useState(false);
    const onToggle = () => setIsOpen(prev => !prev);

    const controlledOpen = "open" in rest ? rest.open : icon ? isOpen : undefined;

    const handleOpenChange = (details: any) => {
      setIsOpen(details.open);
    };

    const additionalProps =
      controlledOpen !== undefined
        ? { open: controlledOpen, onOpenChange: handleOpenChange }
        : {};

    if (disabled) return <>{children}</>;

    return (
      <ChakraTooltip.Root
        openDelay={100}
        closeDelay={100}
        positioning={{ placement }}
        {...rest}
        {...additionalProps}
      >
        <ChakraTooltip.Trigger asChild>
          {children}
        </ChakraTooltip.Trigger>

        <Portal disabled={!portalled} container={portalRef}>
          <ChakraTooltip.Positioner>
            <ChakraTooltip.Content ref={ref} {...contentProps}>
              {showArrow && (
                <ChakraTooltip.Arrow>
                  <ChakraTooltip.ArrowTip {...arrowProps} />
                </ChakraTooltip.Arrow>
              )}
              {icon && showArrow && (
                <FontAwesomeIcon // This icon will be replaced once EukaBark Icon library is available
                  icon={icon}
                  color="var(--euka-colors-royal-blue-500)"
                  fontSize={16}
                  style={{ cursor: "pointer", marginRight: "0.5rem" }}
                  onClick={onToggle}
                />
              )}
              {content}
            </ChakraTooltip.Content>
          </ChakraTooltip.Positioner>
        </Portal>
      </ChakraTooltip.Root>
    );
  }
);

Tooltip.displayName = "Tooltip";

export default Tooltip;
